/* eslint-disable no-use-before-define */
import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { List, Header, Segment, Button, Icon, Label } from 'semantic-ui-react'
import firebase from '../../../config/firebase'

export default class RecentList extends React.Component {
  onEditClick = recentList => {
    const { history } = this.props

    history.push({
      pathname: `/advertisement/recent-restaurant-lists/${recentList.key}/edit`,
      state: { recentList },
    })
  }

  onDeleteClick = listKey => {
    const confirm = window.confirm(`Are you sure to delete this recent list?`)

    if (!confirm) return

    const updates = {}

    updates[`/recent_lists/${listKey}`] = {}

    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) {
          alert(err)
        }
      })
  }

  renderHeader = () => {
    return (
      <div>
        <Header size="large" style={{ display: 'inline-block' }}>
          Recent Restaurant
        </Header>
        <Link to="/advertisement/recent-restaurant-lists/new" style={{ float: 'right' }}>
          <Button icon color="black">
            <Icon name="add" />
          </Button>
        </Link>
      </div>
    )
  }

  renderContent = () => {
    const { recentLists } = this.props
    const orderedRecentLists = _.reverse(Object.values(recentLists))

    if (_.size(recentLists) === 0) {
      return <div style={styles.noResult}>No results</div>
    }

    return (
      <div id="popular-list">
        <List divided verticalAlign="middle">
          {
            orderedRecentLists.map(list => (
              <List.Item
                key={list.key}
                style={styles.listItem}
                active={list.publish}
              >
                <List.Content style={styles.listContent} >
                  <div style={styles.row}>
                    <div>
                      <Label
                        size="tiny"
                        color={list.publish ? 'green' : 'red'}
                      >
                        {list.publish ? 'Publish' : 'Draft'}
                      </Label>
                    </div>
                    <div style={{ marginTop: 5 }}>
                      <h4 style={{ fontWeight: 'normal' }}>
                        List created at&nbsp;
                        <span style={{ color: 'darkgray' }}>
                          {
                            moment(parseInt(list.created_at, 10))
                              .format('DD-MMM-YYYY HH:mm a')
                          }
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div>
                    <Button color="black" onClick={() => this.onEditClick(list)}>
                      Edit
                    </Button>
                    <Button color="red" onClick={() => this.onDeleteClick(list.key)}>
                      Delete
                    </Button>
                  </div>
                </List.Content>
              </List.Item>
            ))
          }
        </List>
      </div>
    )
  }

  render() {
    return (
      <Segment color="black" id='recent-stores'>
        <div>
          {this.renderHeader()}
          {this.renderContent()}
        </div>
      </Segment>
    )
  }
}

const styles = {
  noResult: {
    marginTop: 14
  },
  listItem: {
    padding: '10px 5px 10px 5px',
    color: 'black'
  },
  listContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  }
}


// WEBPACK FOOTER //
// ./src/containers/advertisement/components/RecentList.js